<header class="w3-container" style="padding-top:22px">
  
  <table style="width: 100%"><tr>
	<td style="width:100%"><h5><b><i class="fa fa-book"></i> {{exam}} - {{title}}</b> </h5></td>
	<td><button [class.w3-theme-d4]="lang == 'C'" (click)="setLang('C')" mat-button class="w3-theme-l3" >中</button></td>
	<td><button [class.w3-theme-d4]="lang == 'E'" (click)="setLang('E')" mat-button class="w3-theme-l3" >EN</button></td>	
	</tr>
	</table>
    
  </header> 

  <div class="w3-panel">
    <div class="w3-row-padding" style="margin:0 -16px">
    <div class="w3-container" >
    <table>
      <tr>
      <td>Sort By:</td>      
      <td><button [class.w3-theme-d4]="sort == 'year'" (click)="getQuestion('year')" mat-button style="width:100%" class="w3-half w3-theme-l3 "><i class="fa fa-sort-numeric-asc"></i> Question Number</button></td>
      <td><button [class.w3-theme-d4]="sort == 'rate'" (click)="getQuestion('rate')" mat-button style="width:100%" class="w3-button w3-half w3-theme-l3 "><i class="fa fa-sort-numeric-asc"></i> Correct Rate</button></td>
      
      </tr>
    </table>
    <table *ngIf="started == false && submitted == false"  >
      <tr>
        <td>Mode:</td>
        <td><button matTooltip="Feedback on the whole: show answers upon completion of ALL Qs in each trial." [class.w3-theme-d4]="instant == false" (click)="instant = false" mat-button style="width:100%" class="w3-half w3-theme-l3 "><i class="fa fa-pencil"></i> Normal</button></td>
        <td><button matTooltip="Instant Feedback Mode: show answer upon completion of EACH question." [class.w3-theme-d4]="instant == true" (click)="instant = true" mat-button style="width:100%" class="w3-half w3-theme-l3 "><i class="fa fa-pencil"></i> Instant Feedback</button></td>
      </tr>
    </table>
    <table *ngIf="submitted == false && started == false"  >
      <tr>
        <td>Other:</td>
        <td><button matTooltip="Show the answer directly" class="w3-theme-d4" (click)="submitted = true;instant = true;loadChart(false)" mat-button style="width:100%" class="w3-half w3-theme-l3 "><i class="fa fa-pencil"></i> Show Answer</button></td>
        
      </tr>
    </table>
    </div>
    
   

    <hr>
    <div *ngIf="submitted">
      <mat-card>
        <div *ngIf="submitted && started == true">
          <h5>My Score: {{score}} / {{no_of_questions}} ({{score/no_of_questions | percent}}) </h5>
          {{time}}
          <mat-progress-bar class="w3-theme-d1" style="height: 20px;" mode="determinate" value="{{score/no_of_questions * 100}}"></mat-progress-bar>
          
          <hr>
        </div>
        
          <div id="chartContainer" style="height: 500px; width: 100%;">
            <mat-progress-bar *ngIf="loading == true" mode="indeterminate"></mat-progress-bar>
            
          </div>
          <table style="width:100%">
            <tr>
              <td style="width:50%"><button style="width:100%" class="w3-theme-l3" mat-button (click)="loadChart(false)"><i class="fa fa-users"></i> Same School</button></td>
              <td style="width:50%"><button style="width:100%" class="w3-theme-l3" mat-button (click)="loadChart(true)"><i class="fa fa-users"></i> All Schools</button></td>
            </tr>
          </table>
          
          
          
         
        
    
      </mat-card>
    </div>
    <span *ngIf="this.exam != 'Others'">

    
    <div *ngFor="let question of questions  | async ; index as question_no" class=" w3-section">
        <mat-card>      
            <h5><i *ngIf="answers[question.question_id] == question.ans && submitted" class="fa fa-check w3-text-green"></i>
              <i *ngIf="answers[question.question_id] != question.ans && submitted" class="fa fa-times w3-text-red"></i> Question {{question_no +1}}<span style="font-size: 12px"> - {{question.paper_name}}   Q{{question.question_no}} </span></h5> 
        
          <div class="w3-panel">
            <div class="w3-row-padding" style="margin:0 -16px">
              <div class="w3-half">
                <div style="max-width: 700px;" class=" w3-container w3-middle">
          
                  <p *ngIf="question.paper_id < 35"><img style="max-width: 100%;max-height: 800px;"  src="https://res.cloudinary.com/dw6hcpiyd/image/upload/question/{{question.folder_name}}/{{question.folder_name}}_Q{{question.question_no}}_{{lang}}.png"></p>
                  <p *ngIf="question.paper_id >= 35"><img style="max-width: 100%;max-height: 800px;"  src="https://res.cloudinary.com/dw6hcpiyd/image/upload/bio/{{question.folder_name}}/MC/{{lang}}/{{question.question_no}}.png"></p>
                </div>
              </div>
          
              <div *ngIf=" instant && (answers[question.question_id] != undefined || submitted)" class="w3-half">
                <h5>Statistics</h5>
                <table style="width: 100%" class="w3-table w3-striped w3-white">
                  <tr>
                    <td>A</td> 
                    <td>{{question.A}}</td> 
                    <td style="width: 100%">
                      <div class="w3-theme-l5">
                        <div [class.w3-theme-l4]="answers[question.question_id] == undefined && ( submitted == false || question.ans != 'A')" [class.w3-red]="answers[question.question_id] == 'A' && question.ans != 'A'" [class.w3-green]="(answers[question.question_id] != undefined || submitted) && question.ans == 'A'"  class="w3-container  " [style.width]="question.A / question.all_count| percent">{{question.A / question.all_count | percent}}</div>
                        </div>
                    </td>
                  </tr>
                  <tr>
                    <td>B</td> 
                    <td>{{question.B}}</td> 
                    <td style="width: 100%">
                      <div class="w3-theme-l5">
                        <div [class.w3-theme-l4]="answers[question.question_id] == undefined && ( submitted == false || question.ans != 'B')" [class.w3-red]="answers[question.question_id] == 'B' && question.ans != 'B'" [class.w3-green]="(answers[question.question_id] != undefined || submitted) && question.ans == 'B'"  class="w3-container " [style.width]="question.B / question.all_count| percent">{{question.B / question.all_count | percent}}</div>
                        </div>
                    </td>
                  </tr>
                  <tr>
                    <td>C</td> 
                    <td>{{question.C}}</td> 
                    <td style="width: 100%">
                      <div class="w3-theme-l5">
                        <div [class.w3-theme-l4]="answers[question.question_id] == undefined && ( submitted == false || question.ans != 'C')" [class.w3-red]="answers[question.question_id] == 'C' && question.ans != 'C'" [class.w3-green]="(answers[question.question_id] != undefined || submitted) && question.ans == 'C'"  class="w3-container  " [style.width]="question.C / question.all_count| percent">{{question.C / question.all_count | percent}}</div>
                        </div>
                    </td>
                  </tr>
                  <tr>
                    <td>D</td> 
                    <td>{{question.D}}</td> 
                    <td style="width: 100%">
                      <div class="w3-theme-l5">
                        <div [class.w3-theme-l4]="answers[question.question_id] == undefined && ( submitted == false || question.ans != 'D')" [class.w3-red]="answers[question.question_id] == 'D' && question.ans != 'D'" [class.w3-green]="(answers[question.question_id] != undefined || submitted) && question.ans == 'D'"  class="w3-container"  [style.width]="question.D / question.all_count| percent" >{{question.D / question.all_count | percent}}</div>
                        </div>
                    </td>
                  </tr>
                  <tr>
                    <td>HK</td> 
                    <td>/</td> 
                    <td style="width: 100%">
                      <div class="w3-theme-l5">
                        <div  class="w3-container w3-theme-l3 " [style.width]="question.HK | percent" >{{question.HK | percent}}</div>
                        </div>
                    </td>
                  </tr>
                </table>
                
              </div>
            </div>
          </div>

          <div *ngIf="instant">
          <table style="width: 100%"><tr>
          <td><button [disabled]="answers[question.question_id] != undefined || submitted" [class.w3-theme-l5]="answers[question.question_id] == undefined && ( submitted == false || question.ans != 'A')" [class.w3-green]="(answers[question.question_id] != undefined || submitted) && question.ans == 'A'" [class.w3-red]="answers[question.question_id] == 'A' && question.ans != 'A'"    (click)="checkAns(question,'A')"  mat-button class=" w3-block">A</button></td>
          <td><button [disabled]="answers[question.question_id] != undefined || submitted" [class.w3-theme-l5]="answers[question.question_id] == undefined && ( submitted == false || question.ans != 'B')" [class.w3-green]="(answers[question.question_id] != undefined || submitted) && question.ans == 'B'" [class.w3-red]="answers[question.question_id] == 'B' && question.ans != 'B'"    (click)="checkAns(question,'B')"  mat-button class="w3-theme-l5 w3-block ">B</button></td>
          <td><button [disabled]="answers[question.question_id] != undefined || submitted" [class.w3-theme-l5]="answers[question.question_id] == undefined && ( submitted == false || question.ans != 'C')" [class.w3-green]="(answers[question.question_id] != undefined || submitted) && question.ans == 'C'" [class.w3-red]="answers[question.question_id] == 'C' && question.ans != 'C'"    (click)="checkAns(question,'C')" mat-button class="w3-theme-l5 w3-block ">C</button></td>
          <td><button [disabled]="answers[question.question_id] != undefined || submitted" [class.w3-theme-l5]="answers[question.question_id] == undefined && ( submitted == false || question.ans != 'D')" [class.w3-green]="(answers[question.question_id] != undefined || submitted) && question.ans == 'D'" [class.w3-red]="answers[question.question_id] == 'D' && question.ans != 'D'"    (click)="checkAns(question,'D')" mat-button class="w3-theme-l5 w3-block ">D</button></td>
          </tr>
          </table>
          <br *ngIf="answers[question.question_id] != undefined || submitted">
         
          <table *ngIf="answers[question.question_id] != undefined || submitted" style="width: 100%"><tr>
              <td style="width: 50%">
                <button (click)="openYoutubeDialog(question)" [disabled]="question.youtube == ''" [class.w3-disabled]="question.youtube == ''" mat-button class="w3-theme-l3 w3-block ">
                <i class="fa fa-youtube-play"></i> Youtube</button>
              </td>
          <td style="width: 50%"><button (click)="openAnswerDialog(question,lang)" mat-button class="w3-theme-l3 w3-block "><i class="fa fa-file-picture-o"></i> Solution</button></td>
          
         
          </tr>
          </table>
          

            
    
        </div>
        <div *ngIf="instant == false">
          <table style="width: 100%"><tr>
            <td><button [class.w3-theme-l5]="answers[question.question_id] == undefined" [class.w3-theme-d4]="answers[question.question_id] == 'A' "    (click)="checkAns(question,'A')"  mat-button class="w3-theme-l5 w3-block">A</button></td>
            <td><button [class.w3-theme-l5]="answers[question.question_id] == undefined" [class.w3-theme-d4]="answers[question.question_id] == 'B' "    (click)="checkAns(question,'B')"  mat-button class="w3-theme-l5 w3-block ">B</button></td>
            <td><button [class.w3-theme-l5]="answers[question.question_id] == undefined" [class.w3-theme-d4]="answers[question.question_id] == 'C' "    (click)="checkAns(question,'C')" mat-button class="w3-theme-l5 w3-block ">C</button></td>
            <td><button [class.w3-theme-l5]="answers[question.question_id] == undefined" [class.w3-theme-d4]="answers[question.question_id] == 'D' "    (click)="checkAns(question,'D')" mat-button class="w3-theme-l5 w3-block ">D</button></td>
            </tr>
            </table>
        </div>
        </mat-card>
    </div>
 
  </span>
  <!-- Others-->
  <span *ngIf="this.exam == 'Others'">

    
    <div *ngFor="let question of questions  | async ; index as question_no" class=" w3-section">
        <mat-card>      
            <h5><i *ngIf="answers[question.question_id] == question.ans && submitted" class="fa fa-check w3-text-green"></i>
              <i *ngIf="answers[question.question_id] != question.ans && submitted" class="fa fa-times w3-text-red"></i> Question {{question_no +1}}</h5> 
        
          <div class="w3-panel">
            <div class="w3-row-padding" style="margin:0 -16px">
              <div class="w3-half">
                <div style="max-width: 700px;" class=" w3-container w3-middle">
     
                <div  *ngIf="lang == 'E'" [innerHTML]="question.eng_question">
                </div>
                <div  *ngIf="lang == 'C'" [innerHTML]="question.chi_question">
                </div>
              </div>
              </div>
          
              <div *ngIf=" instant && (answers[question.question_id] != undefined || submitted)" class="w3-half">
                <h5>Statistics</h5>
                <table style="width: 100%" class="w3-table w3-striped w3-white">
                  <tr>
                    <td>A</td> 
                    <td>{{question.A}}</td> 
                    <td style="width: 100%">
                      <div class="w3-theme-l5">
                        <div [class.w3-theme-l4]="answers[question.question_id] == undefined && ( submitted == false || question.ans != 'A')" [class.w3-red]="answers[question.question_id] == 'A' && question.ans != 'A'" [class.w3-green]="(answers[question.question_id] != undefined || submitted) && question.ans == 'A'"  class="w3-container  " [style.width]="question.A / question.all_count| percent">{{question.A / question.all_count | percent}}</div>
                        </div>
                    </td>
                  </tr>
                  <tr>
                    <td>B</td> 
                    <td>{{question.B}}</td> 
                    <td style="width: 100%">
                      <div class="w3-theme-l5">
                        <div [class.w3-theme-l4]="answers[question.question_id] == undefined && ( submitted == false || question.ans != 'B')" [class.w3-red]="answers[question.question_id] == 'B' && question.ans != 'B'" [class.w3-green]="(answers[question.question_id] != undefined || submitted) && question.ans == 'B'"  class="w3-container " [style.width]="question.B / question.all_count| percent">{{question.B / question.all_count | percent}}</div>
                        </div>
                    </td>
                  </tr>
                  <tr>
                    <td>C</td> 
                    <td>{{question.C}}</td> 
                    <td style="width: 100%">
                      <div class="w3-theme-l5">
                        <div [class.w3-theme-l4]="answers[question.question_id] == undefined && ( submitted == false || question.ans != 'C')" [class.w3-red]="answers[question.question_id] == 'C' && question.ans != 'C'" [class.w3-green]="(answers[question.question_id] != undefined || submitted) && question.ans == 'C'"  class="w3-container  " [style.width]="question.C / question.all_count| percent">{{question.C / question.all_count | percent}}</div>
                        </div>
                    </td>
                  </tr>
                  <tr>
                    <td>D</td> 
                    <td>{{question.D}}</td> 
                    <td style="width: 100%">
                      <div class="w3-theme-l5">
                        <div [class.w3-theme-l4]="answers[question.question_id] == undefined && ( submitted == false || question.ans != 'D')" [class.w3-red]="answers[question.question_id] == 'D' && question.ans != 'D'" [class.w3-green]="(answers[question.question_id] != undefined || submitted) && question.ans == 'D'"  class="w3-container"  [style.width]="question.D / question.all_count| percent" >{{question.D / question.all_count | percent}}</div>
                        </div>
                    </td>
                  </tr>
                  <tr>
                    <td>HK</td> 
                    <td>/</td> 
                    <td style="width: 100%">
                      <div class="w3-theme-l5">
                        <div  class="w3-container w3-theme-l3 " [style.width]="question.HK | percent" >{{question.HK | percent}}</div>
                        </div>
                    </td>
                  </tr>
                </table>
                
              </div>
            </div>
          </div>

          <div *ngIf="instant">
          <table style="width: 100%"><tr>
          <td><button [disabled]="answers[question.question_id] != undefined || submitted" [class.w3-theme-l5]="answers[question.question_id] == undefined && ( submitted == false || question.ans != 'A')" [class.w3-green]="(answers[question.question_id] != undefined || submitted) && question.ans == 'A'" [class.w3-red]="answers[question.question_id] == 'A' && question.ans != 'A'"    (click)="checkAns(question,'A')"  mat-button class=" w3-block">A</button></td>
          <td><button [disabled]="answers[question.question_id] != undefined || submitted" [class.w3-theme-l5]="answers[question.question_id] == undefined && ( submitted == false || question.ans != 'B')" [class.w3-green]="(answers[question.question_id] != undefined || submitted) && question.ans == 'B'" [class.w3-red]="answers[question.question_id] == 'B' && question.ans != 'B'"    (click)="checkAns(question,'B')"  mat-button class="w3-theme-l5 w3-block ">B</button></td>
          <td><button [disabled]="answers[question.question_id] != undefined || submitted" [class.w3-theme-l5]="answers[question.question_id] == undefined && ( submitted == false || question.ans != 'C')" [class.w3-green]="(answers[question.question_id] != undefined || submitted) && question.ans == 'C'" [class.w3-red]="answers[question.question_id] == 'C' && question.ans != 'C'"    (click)="checkAns(question,'C')" mat-button class="w3-theme-l5 w3-block ">C</button></td>
          <td><button [disabled]="answers[question.question_id] != undefined || submitted" [class.w3-theme-l5]="answers[question.question_id] == undefined && ( submitted == false || question.ans != 'D')" [class.w3-green]="(answers[question.question_id] != undefined || submitted) && question.ans == 'D'" [class.w3-red]="answers[question.question_id] == 'D' && question.ans != 'D'"    (click)="checkAns(question,'D')" mat-button class="w3-theme-l5 w3-block ">D</button></td>
          </tr>
          </table>
          <br *ngIf="answers[question.question_id] != undefined || submitted">
         
          <table *ngIf="answers[question.question_id] != undefined || submitted" style="width: 100%"><tr>
              <td style="width: 50%">
                <button (click)="openYoutubeDialog(question)" [disabled]="question.youtube == ''" [class.w3-disabled]="question.youtube == ''" mat-button class="w3-theme-l3 w3-block ">
                <i class="fa fa-youtube-play"></i> Youtube</button>
              </td>
          <td style="width: 50%"><button (click)="openAnswerDialog(question,lang)" mat-button class="w3-theme-l3 w3-block "><i class="fa fa-file-picture-o"></i> Solution</button></td>
          
         
          </tr>
          </table>
          
          <div *ngIf="answers[question.question_id] != undefined || submitted" style="max-height: 250px; overflow: scroll;">
         <br>
          <table   class="w3-table w3-striped w3-hide" >
            <tr>
              <td><img [src]="user.getImage()" class="w3-circle w3-margin-right" style="width:30px"></td>
              <td style="width:100%"><input #comment (keyup.enter)="updateComment(question.question_id,comment.value)" class="w3-input" placeholder="Comment"></td>
            </tr>
            <tr>
              <td><img [src]="user.getImage()" class="w3-circle w3-margin-right" style="width:30px"></td>
              <td style="width:100%"><b>Admin</b> 2019-12-26 20:17<br>Coming Soon!!</td>
            </tr>
            
          </table>
        </div>
            
    
        </div>
        <div *ngIf="instant == false">
          <table style="width: 100%"><tr>
            <td><button [class.w3-theme-l5]="answers[question.question_id] == undefined" [class.w3-theme-d4]="answers[question.question_id] == 'A' "    (click)="checkAns(question,'A')"  mat-button class="w3-theme-l5 w3-block">A</button></td>
            <td><button [class.w3-theme-l5]="answers[question.question_id] == undefined" [class.w3-theme-d4]="answers[question.question_id] == 'B' "    (click)="checkAns(question,'B')"  mat-button class="w3-theme-l5 w3-block ">B</button></td>
            <td><button [class.w3-theme-l5]="answers[question.question_id] == undefined" [class.w3-theme-d4]="answers[question.question_id] == 'C' "    (click)="checkAns(question,'C')" mat-button class="w3-theme-l5 w3-block ">C</button></td>
            <td><button [class.w3-theme-l5]="answers[question.question_id] == undefined" [class.w3-theme-d4]="answers[question.question_id] == 'D' "    (click)="checkAns(question,'D')" mat-button class="w3-theme-l5 w3-block ">D</button></td>
            </tr>
            </table>
        </div>
        </mat-card>
    </div>
 
  </span>
    <div *ngIf="started && submitted == false && (questions | async)?.length > 0" class="w3-bottom w3-bar w3-theme-d3">
        
    <div  mat-button class="w3-theme-d2 w3-large" style="z-index:4">
     
    <button (click)="submitMC();loadChart(false)" mat-button type="submit"  class="w3-green w3-block w3-small " style="white-space: normal;"><i class="fa fa-check"></i> Submit ({{time}}) </button>
    </div>

    </div>
    <br>
    